import { useQuery } from '@apollo/client';
import { ALL_TABLES, Loader, useSuperListHook } from '@nile/components';
import { GET_TASK_LISTVIEW_META } from '@nile/mangifera/src/Graphql/Mutations/ticketview';
import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedTaskFilter';
import AdvancedFilter from '@nile/components/src/Components/AdvancedFilter';
import React from 'react';

function AdvancedTaskFilter(props) {
  const { viewId, tableName } = props;

  const {
    advanceFilterCondition,
    updateAdvanceFilterCondition
  } = useSuperListHook({
    viewId: viewId,
    tableName: tableName
  });

  const updateAdvanceFilter = (updatedConditions) => {
    updateAdvanceFilterCondition(updatedConditions);
  };
  const {
    loading: taskListViewMetaLoading,
    error: taskAutomationError,
    data: taskListViewMeta
  } = useQuery(GET_TASK_LISTVIEW_META);
  if (taskListViewMetaLoading) return <Loader />;
  if (taskAutomationError) return <div>error...</div>;

  return (
    <div>
      <AdvancedFilter
        listMeta={taskListViewMeta.getTaskListViewMetaInfo}
        currentModule="task"
        conditions={advanceFilterCondition}
        onAttributeSelect={onAttributeSelect}
        onValueSearch={onValueSearch}
        updateCondition={updateAdvanceFilter}
        isNewBuilder
      />
    </div>
  );
}

export default AdvancedTaskFilter;
